module.exports = __webpack_public_path__ + "img/5201.02bfc67d.png";